import { Table as TableAnt } from "antd"
import type { ColumnsType, TablePaginationConfig, TableProps } from "antd/es/table"
import { TableProvider } from "components/providers/Table.provider"
import { MouseEventHandler } from "react"

type Props<ColumnsDataType> = {
	className?: string
	columns: ColumnsType<ColumnsDataType>
	data: ColumnsDataType[]
	total?: number
	current?: number
	loading?: boolean
	scrollY?: number
	showHeader?: boolean
	onChange?: TableProps<ColumnsDataType>["onChange"]
	onRow?: (record: ColumnsDataType) => {
		onClick: MouseEventHandler<HTMLTableRowElement>
	}
	rowClassName?: TableProps<ColumnsDataType>["rowClassName"]
	position?: TablePaginationConfig["position"]
	bordered?: boolean
	pagination?: boolean
}

export const Table = <ColumnsDataType extends object>({
	className = "",
	columns,
	data,
	total,
	current,
	onChange,
	position = ["bottomRight"],
	onRow,
	rowClassName,
	loading,
	showHeader = true,
	scrollY,
	bordered,
	pagination = true,
}: Props<ColumnsDataType>) => {
	return (
		<TableProvider>
			<TableAnt
				className={`Table ${className}`}
				columns={columns}
				dataSource={data}
				onRow={onRow}
				rowClassName={rowClassName}
				onChange={onChange}
				loading={loading}
				scroll={{ y: scrollY }}
				showHeader={showHeader}
				bordered={bordered}
				pagination={
					pagination
						? {
								position: position,
								total: total,
								current: current,
								showQuickJumper: true,
								showSizeChanger: false,
							}
						: false
				}
			/>
		</TableProvider>
	)
}
